var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"squishy"},[_c('h1',[_vm._v("Transaction Cancelled")]),_c('h2',[_vm._v("(Thanks anyway!)")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }